import PageMeta from '../../components/common/PageMeta'
import Calendar from './Calendar/Calendar'
import OpenNotes from './Notes/OpenNotes'
import DashboardOverview from './Overview/DashboardOverview'
import SectionHeader from './SectionHeader'

export default function DashboardPage() {
    return (
        <>
            <PageMeta title='Início | CRM' description='Página inicial do CRM' />
            <div className='space-y-8'>
                <div className='grid grid-cols-1 items-stretch gap-6 lg:grid-cols-12'>
                    <section className='flex min-w-0 flex-col lg:col-span-8' aria-labelledby='calendar-title'>
                        <SectionHeader eyebrow='Agenda' title='Calendário' titleID='calendar-title' />
                        <div className='min-h-0 flex-1'>
                            <Calendar />
                        </div>
                    </section>

                    <section className='flex min-w-0 flex-col lg:col-span-4' aria-labelledby='open-notes-title'>
                        <SectionHeader eyebrow='Acompanhamento' title='Minhas notas abertas' titleID='open-notes-title' />
                        <div className='relative min-h-0 flex-1'>
                            <div className='h-[480px] lg:absolute lg:inset-0 lg:h-auto'>
                                <OpenNotes />
                            </div>
                        </div>
                    </section>
                </div>

                <DashboardOverview />
            </div>
        </>
    )
}
